import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { history } from '../store'

import AppBaqueiraHeader from '../containers/AppBaqueiraHeader'

import { authLogout } from '../actions/auth'
import { withNamespaces } from "react-i18next";
import { postRedsysGetParams } from '../actions/qrs'

class PaymentBaqueiraError extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
      qr: "",
    }

    this.toggle = this.toggle.bind(this);
    this.logout = this.logout.bind(this);

  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  logout() {
    this.props.authLogout()
    this.props.push('/login')
  }

  goTo(number, e) {
    const { qr } = this.state
    history.push(`/qrsale/${qr}`)
  }

  componentDidMount() {
    const searchParams = new URLSearchParams(this.props.location.search);
    const qr = searchParams.get('qr');
    const language = searchParams.get('language');

    const dsSignatureVersion = searchParams.get('Ds_SignatureVersion');
    const dsMerchantParameters = searchParams.get('Ds_MerchantParameters');
    const dsSignature = searchParams.get('Ds_Signature');

    const paramsRedsys = {
      Ds_SignatureVersion: dsSignatureVersion,
      Ds_MerchantParameters: dsMerchantParameters,
      Ds_Signature: dsSignature,
      parameterToFetch: 'all'
    }

    this.props.postRedsysGetParams(paramsRedsys)
      .then((answer) => {

        console.log("answer redsys: ", answer);

        this.props.i18n.changeLanguage(language);

        this.setState({
          qr: qr,
        });

      })
      .catch((error) => {
        console.error(error);
      });

  }

  render() {
    const { t } = this.props
    return (
      <div className="baqueiraBackground">
        <AppBaqueiraHeader />
        <div className="nm-page">
          <div className="bq-form" style={{ textAlign: 'center' }}>
            <img
              src="/images/incidences.svg"
              alt="Error"
              style={{ width: 120, margin: '0 auto 16px', display: 'block' }}
            />
            <h3 className="bq-form-title" style={{ textAlign: 'center' }}>{t('ERROR')}</h3>
            <p className="bq-form-desc" style={{ textAlign: 'center' }}>
              {t('No se ha podido realizar la compra. Vuelve a intentarlo más tarde.')}
            </p>
            <button className="bq-btn-back" onClick={e => this.goTo(1, e)}>
              {t('VOLVER AL INICIO')}
            </button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: true
})

const mapDispatchToProps = dispatch => ({
  authLogout: bindActionCreators(authLogout, dispatch),
  push: bindActionCreators(push, dispatch),
  postRedsysGetParams: bindActionCreators(postRedsysGetParams, dispatch),
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(PaymentBaqueiraError));